<template>
  <div>
    <div class="ticket_info_user_title ticket_icon">
      <div class="way_title_left">
        <img :src="staticAssets.ImgObj.address_people" alt />
        <span>{{TLang('收货地址','address')}}</span>
      </div>
      <el-popover
        placement="left"
        width="156"
        height="32"
        trigger="manual"
        popper-class="qr_code_add"
        v-model="tips_address_model"
      >
        <span>
          <img :src="staticAssets.ImgObj.tips_icon" alt />
          {{TLang('请添加收货地址信息','my')}}
        </span>
        <a
          href="javascript:;"
          class="ticket_info_address_add"
          :class="address_move_flag ? 'address_move_flag_disabled' : ''"
          slot="reference"
          @click="ticketAddressAdd"
          @mouseover="addMouseEnter"
          @mouseleave="addMouseOut"
        >
          <img
            :src="
              address_move_flag
                ? staticAssets.ImgObj.address_add
                : staticAssets.ImgObj.address_add_disabled
            "
            alt
          />
          {{TLang('新建收货地址','address')}}
        </a>
      </el-popover>
    </div>

    <div class="ticket_info_user_table">
      <div class="ticket_info_empty" v-if="this.cardTableAddress.length < 1">
        {{TLang('暂无收货地址','my')}}
      </div>
      <div
        v-for="(card_item, cIndex) in cardTableAddress"
        :key="`card${cIndex}`"
        class="ticket_info_user_item"
        :class="{
          active_background:
            operate_address_flag == parseInt(cIndex + 1) ||
            card_item.defaultAddress == 1
        }"
        @mouseover="addressMouseEnter(cIndex)"
        @mouseleave="addressMouseOut(cIndex)"
        @click="getCheckedAddress(card_item, cIndex)"
      >
        <div class="info_left">
          <span
            class="user_item_name"
            :class="{
              user_item_name_move: operate_name_flag == parseInt(cIndex + 1),
              user_item_name_checked:
                name_checked_flag == parseInt(cIndex + 1) ||
                (name_checked_flag == 0 && cIndex == 0) ||
                cardTableAddress.length == 1
            }"
            @mouseover="nameItemEnter(cIndex)"
            @mouseleave="nameItemOut(cIndex)"
            >{{ card_item.consignee }}</span
          >
          <a
            href="javascript:;"
            class="user_itm_name_address"
            :title="card_item.consignee"
            >{{ card_item.consignee }}</a
          >
          <div class="address_detail">
            <a
              href="javascript:;"
              class="user_item_tel_nomal"
              :title="card_item.address"
            >
              {{
                `${card_item.provinceName} ${card_item.cityName} ${card_item.regionName} ${card_item.streetName} ${card_item.address}`
              }}
            </a>
          </div>
          <span style="margin: 0 16px;">
            {{ publicMethod.addressExchangeTel(card_item.mobile) }}
          </span>
        </div>
        <div
          class="operate_right"
          v-if="operate_address_flag == parseInt(cIndex + 1)"
        >
          <a
            href="javascript:;"
            class="edit_left"
            :class="{
              active_edit: address_edit_flag == parseInt(cIndex + 1)
            }"
            @mouseover="editMouseEnter(cIndex)"
            @mouseleave="editMouseOut(cIndex)"
            @click.prevent.stop="editAddressInfo(cIndex, card_item)"
          >
            <img
              :src="
                address_edit_flag == parseInt(cIndex + 1)
                  ? staticAssets.ImgObj.select_edit
                  : staticAssets.ImgObj.default_edit
              "
              alt
            />
            <span>{{TLang('修改','address')}}</span>
          </a>
          <a
            href="javascript:;"
            class="delete_right"
            :class="{
              active_edit: address_del_flag == parseInt(cIndex + 1)
            }"
            @mouseover="delMouseEnter(cIndex)"
            @mouseleave="delMouseOut(cIndex)"
            @click.prevent.stop="delAddressInfo(cIndex)"
          >
            <img
              :src="
                address_del_flag == parseInt(cIndex + 1)
                  ? staticAssets.ImgObj.select_delete
                  : staticAssets.ImgObj.default_delete
              "
              alt
            />
            <span>{{TLang('删除','address')}}</span>
          </a>
        </div>
      </div>
      <div
        class="ticket_info_location_more"
        @click="getLocationMore"
        @mouseover="moreMouseEnter"
        @mouseleave="moreMouseOut"
        :class="{ locaton_more_checked: hover_click_flag }"
        v-if="cardTableAddress_flag"
      >
        <span>{{ select_click_flag ? TLang('收起地址', 'my') : TLang('更多地址', 'address') }}</span>
        <img
          :src="
            select_click_flag
              ? hover_click_flag
                ? staticAssets.ImgObj.location_arrow_top
                : staticAssets.ImgObj.location_arrow_hover
              : hover_click_flag
              ? staticAssets.ImgObj.select_arrow_hover
              : staticAssets.ImgObj.select_arrow_bottom
          "
          alt
        />
      </div>
      <div
        class="user_ticket_info"
        v-if="real_type == 1 && kuaidi_flag"
        style="margin-bottom:32px;"
      >
        <el-form
          :model="cardForm_kuaidi"
          :rules="cardRules"
          ref="cardForm_kuaidi"
        >
          <el-form-item label="身份证" label-width="56px" prop="ownerIdCardNo">
            <el-input
              v-model="cardForm_kuaidi.ownerIdCardNo"
              autocomplete="off"
              placeholder="请输入18位身份证号码"
              @input="formatCardNo"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-dialog
      class="ticket-mobile-dialog ticket-mobile-address"
      :title="addressAddFlag ? TLang('新增收货地址','home',false,false,null) : TLang('编辑收货地址','home',false,false,null)"
      :visible.sync="addressVisible"
      width="747px"
      center
      :close-on-click-modal="false_flag"
      @click.native="dialogClick"
    >
      <div class="address_title">
        <div class="title_left">{{TLang('温馨提示','address')}}</div>
        <div class="title_right">
          {{TLang('邮管局通知所有快递配送物流信','my')}}
        </div>
      </div>
      <el-form
        :model="addressRules"
        :rules="ticketAddressRules"
        ref="addressRules"
        label-width="66px"
      >
        <el-form-item :label="TLang('收货人','address',false,false,null)" prop="name" :class="!CheckCN() ? 'label-one label-one-Tab':'label-one'">
          <el-input v-model="addressRules.name"></el-input>
        </el-form-item>
        <el-form-item :label="TLang('手机号码','address',false,false,null)" prop="mobile" :class="!CheckCN() ? 'label-one label-one-Tab':'label-one'">
          <el-input
            v-model="addressRules.mobile"
            maxlength="11"
            @input="addressRules.mobile = addressRules.mobile.replace(/\D/, '')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="TLang('所在地区','address',false,false,null)" prop="location" :class="!CheckCN() ? 'label-one label-one-Wat':'label-one'">
          <el-col
            class="location_area_wrap"
            style="width: calc(100% - 13px);position:relative"
          >
            <el-input
              v-model="addressRules.location"
              @click.native.prevent.stop="getChangeLocation"
            ></el-input>
            <img
              class="location_arrow"
              :src="
                select_location_flag
                  ? staticAssets.ImgObj.select_arrow_top
                  : staticAssets.ImgObj.select_arrow_bottom
              "
              alt
            />
            <div
              class="location_area"
              v-if="select_location_flag"
              @click.prevent.stop="preStop"
            >
              <selectArea @getCityId="this.getCityId" />
            </div>
          </el-col>
        </el-form-item>
        <el-form-item :label="TLang('详细地址','address',false,false,null)" prop="address" :class="!CheckCN() ? 'label-one label-one-Tab':'label-one'">
          <el-input v-model="addressRules.address"></el-input>
        </el-form-item>
        <el-form-item :label="TLang('固定号码','address',false,false,null)" class="check_none" :class="!CheckCN() ? 'label-one label-one-Tab':'label-one'">
          <el-input v-model="addressRules.telPhone"></el-input>
        </el-form-item>
        <el-form-item :label="TLang('邮政编码','address',false,false,null)" class="check_none" :class="!CheckCN() ? 'label-one label-one-Tab':'label-one'">
          <el-input v-model="addressRules.zipCode"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="submit-btn"
          type="primary"
          @click="submitAddressVisible('addressRules')"
          >{{TLang('保存','list')}}</el-button
        >
        <el-button class="cancel-btn" @click="addressVisible = false"
          >{{TLang('取消','home')}}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getCookie } from "@/utils";
export default {
  name: "TicketAddress",
  data() {
    var card_checked = (rule, value, callback) => {
      if (!value && parseInt(value) != 0) {
        callback(new Error(TLang('身份证号码不能为空','address',false,false,null)));
      } else {
        let currvalue = value.replace(/\s*/g, ""); //去除空格
        if (!/^\d{17}[0-9a-zA-Z]{1}$/.test(currvalue)) {
          callback(new Error(TLang('请输入正确的身份证号码','address',false,false,null)));
        }
        callback();
      }
    };
    var name_checked = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(TLang('姓名不能为空','address',false,false,null)));
      } else if (value.length > 20) {
        return callback(new Error(TLang('姓名长度不能超过20个字符','address',false,false,null)));
      } else {
        if (value.indexOf("先生") > 0 || value.indexOf("小姐") > 0) {
          callback(
            new Error(
              TLang('不允许出现X先生/X小姐详情阅读温馨提示','address',false,false,null)
            )
          );
        }
        callback();
      }
    };
    var location_checked = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(TLang('所在地区不能为空','address',false,false,null)));
      } else {
        if (value != this.addressName) {
          callback(new Error(TLang('请您输入完整的地区信息','address',false,false,null)));
        }
        callback();
      }
    };
    var tel_checked = (rule, value, callback) => {
      if (!value && parseInt(value) != 0) {
        callback(new Error(TLang('手机号不能为空','address',false,false,null)));
      } else {
        if (!/^1\d{10}$/.test(value)) {
          callback(new Error(TLang('请输入正确的手机号码','address',false,false,null)));
        }
        callback();
      }
    };
    var address_checked = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(TLang('详细地址不能为空','address',false,false,null)));
      } else {
        if (value.length > 50) {
          callback(new Error(TLang('详细地址长度不能超过50个字符','address',false,false,null)));
        }
        callback();
      }
    };
    return {
      cardForm_kuaidi: {
        ownerIdCardNo: ""
      },
      cardRules: {
        ownerIdCardNo: [{ validator: card_checked, trigger: "blur" }]
      },
      cardTableAddress_flag: this.address_more, //是否展示更多地址
      select_click_flag: false, //是否点击下拉更多地址
      hover_click_flag: false, //下拉 hover 更多地址
      name_checked_flag: this.checked_flag, //当前选中用户名
      lastAddressId: this.lastOrderAddress,
      operate_name_flag: 0, //当前用户名
      operate_address_flag: 0, //用户行数判定
      address_del_flag: 0, //地址删除active判定
      address_edit_flag: 0, //地址编辑active判定
      address_move_flag: false,
      tips_address_model: this.tips_flag,
      addressAddFlag: true,
      addressVisible: false,
      false_flag: false, //遮罩层关闭
      formLabelWidth: "56px",
      cardTableAddress: this.addressSource,
      real_type: this.real_name_type,
      kuaidi_flag: this.kuaidi_type,
      table_source: this.tableTicket_data,
      addressRules: this.staticAssets.addressRules,
      select_location_flag: false,
      areaList: [],
      addressName: "",
      ticketAddressRules: {
        name: [{ validator: name_checked, trigger: "blur" }],
        location: [{ validator: location_checked, trigger: "change" }],
        mobile: [{ validator: tel_checked, trigger: "blur" }],
        address: [{ validator: address_checked, trigger: "blur" }]
      },
      CookiesOne: getCookie('df_lang'),
    };
  },
  props: [
    "addressSource", //地址数据源
    "real_name_type", //实名制类型
    "kuaidi_type", //是否是快递票
    "checked_flag", //当前选中用户
    "tableTicket_data", //详情页数据
    "lastOrderAddress", //是否存在最后一次下单id
    "tips_flag", //提醒添加地址 tips
    "address_more" //是否显示更多地址
  ],
  watch: {
    tableTicket_data: {
      handler: function(newVal) {
        this.table_source = newVal;
      },
      deep: true,
      immediate: true
    },
    addressSource: {
      handler: function(newVal) {
        this.cardTableAddress = newVal;
      },
      deep: true,
      immediate: true
    },
    address_more(val) {
      this.cardTableAddress_flag = val;
    },
    real_name_type(val) {
      this.real_type = val;
    },
    kuaidi_type(val) {
      this.kuaidi_flag = val;
    },
    checked_flag(val) {
      this.name_checked_flag = val;
    },
    lastOrderAddress(val) {
      this.lastAddressId = val;
    },
    tips_flag(val) {
      this.tips_address_model = val;
    }
  },
  components: {
    selectArea: () => import("../../components/selectArea") //地址三级联动
  },
  beforeCreate() {},
  created() {
    this.$refs["cardRules"] ? this.$refs["cardRules"].resetFields() : "";
  },
  destroyed() {},
  computed: {},
  methods: {
    formatCardNo() {
      this.cardForm_kuaidi.ownerIdCardNo = this.cardForm_kuaidi.ownerIdCardNo
        .replace(/[^0-9A-z]/g, "")
        .toUpperCase();
      this.formatDeepCard();
    },
    formatDeepCard() {
      this.cardForm_kuaidi.ownerIdCardNo = this.cardForm_kuaidi.ownerIdCardNo.replace(
        /[^0-9A-z]/g,
        ""
      );
      let valLength = this.cardForm_kuaidi.ownerIdCardNo.replace(
        /[^0-9A-z]/g,
        ""
      ).length;
      if (valLength > 6 && valLength <= 14) {
        this.cardForm_kuaidi.ownerIdCardNo =
          this.cardForm_kuaidi.ownerIdCardNo.slice(0, 6) +
          " " +
          this.cardForm_kuaidi.ownerIdCardNo.slice(6);
      } else if (valLength > 14) {
        this.cardForm_kuaidi.ownerIdCardNo =
          this.cardForm_kuaidi.ownerIdCardNo.slice(0, 6) +
          " " +
          this.cardForm_kuaidi.ownerIdCardNo.slice(6, 14) +
          " " +
          this.cardForm_kuaidi.ownerIdCardNo.slice(14);
      } else {
        this.cardForm_kuaidi.ownerIdCardNo = this.cardForm_kuaidi.ownerIdCardNo;
      }
    },
    //重置dialog表单
    getResetDialog(refName) {
      this.$refs[refName] ? this.$refs[refName].resetFields() : "";
    },
    preStop() {
      //console.log("阻止dialog冒泡");
    },
    //选择省市区
    getChangeLocation() {
      this.select_location_flag = !this.select_location_flag;
    },
    //手动选择地址 获取地址id
    getCityId(arr) {
      this.areaList = arr;
      let newArr = [];
      newArr = [].concat(arr);
      this.addressName = "";
      newArr.map((item, index) => {
        index != 3
          ? (this.addressName += `${item && item.name} / ` || "")
          : (this.addressName += (item && item.name) || "");
      });
      //赋值addressDialog 地址
      this.addressRules.location = this.addressName;
      this.addressRules.provinceId = arr[0] && arr[0].id;
      this.addressRules.regionId = arr[2] && arr[2].id;
      this.addressRules.cityId = arr[1] && arr[1].id;
      this.addressRules.streetId = arr[3] && arr[3].id;
      this.select_location_flag = false; //关闭地址选择
    },
    //编辑收货地址
    editAddressInfo(eIndex, editData) {
      this.getResetDialog("addressRules");
      this.addressVisible = true; //打开地址dialog
      this.addressAddFlag = false; //标记为编辑
      let locationName =
        editData.provinceName +
        " / " +
        editData.cityName +
        " / " +
        editData.regionName +
        " / " +
        editData.streetName;
      this.addressName = locationName;
      this.addressRules = Object.assign({}, editData, {
        name: editData.consignee,
        location: locationName,
        telPhone: editData.telephone
      });
    },
    //地址dialog保存
    submitAddressVisible(form_data) {
      this.$refs[form_data].validate(valid => {
        if (valid) {
          // 地址参数
          const addressData = {
            //userId: this.userId,
            provinceId: this.addressRules.provinceId,
            regionId: this.addressRules.regionId,
            cityId: this.addressRules.cityId,
            streetId: this.addressRules.streetId,
            consignee: this.addressRules.name,
            address: this.addressRules.address,
            mobile: this.addressRules.mobile,
            telephone: this.addressRules.telPhone,
            zipCode: this.addressRules.zipCode,
            lastOrder: null,
            defaultAddress: null
          };
          if (this.addressAddFlag) {
            //上传新增地址
            this.apis.showOrder.getNewAddAddress(addressData).then(data => {
              if (!data.code) {
                this.publicMethod.getThrowInfo("新增地址成功", "success");
                this.addressVisible = false;
                this.getUserAddressAll(data.body); //更新地址列表
                this.address_newId = data.body;
                this.name_checked_flag = 0; //新增将标记置零
              } else {
                this.publicMethod.getThrowInfo(data.msg, "error");
              }
            });
          } else {
            //合并地址参数
            let orderData = Object.assign({}, addressData, {
              //userAddressId: this.addressRules.id,
              id: this.addressRules.id
            });
            this.apis.showOrder.getEditAddress(orderData).then(data => {
              if (!data.code) {
                // 更新收货地址信息
                this.publicMethod.getThrowInfo(data.body, "success");
                this.addressVisible = false;
                //重载收货地址信息
                this.getUserAddressAll(this.lastAddressId);
              } else {
                this.publicMethod.getThrowInfo(data.msg, "error");
              }
            });
          }
        } else {
          //this.publicMethod.getThrowInfo(datasource.msg, "error");
        }
      });
    },
    //点击dialog其他部分关闭地址选择
    dialogClick() {
      this.select_location_flag ? (this.select_location_flag = false) : "";
    },
    //添加收货地址
    ticketAddressAdd() {
      this.addressVisible = true; //非确认提交dialog
      this.addressAddFlag = true; //新增状态false
      this.getResetDialog("addressRules");
      this.resetAddressRules();
      this.tips_address_model = false; //tips提示开关
      this.$emit("resetTips", this.tips_address_model);
    },
    //新增重置
    resetAddressRules() {
      (this.addressRules.name = ""),
        (this.addressRules.location = ""),
        (this.addressRules.address = ""),
        (this.addressRules.mobile = ""),
        (this.addressRules.telPhone = ""),
        (this.addressRules.zipCode = "");
    },
    //添加收货地址 mouseEnter 事件
    addMouseEnter() {
      this.address_move_flag = true;
    },
    //添加收货地址 mouseOut 事件
    addMouseOut() {
      this.address_move_flag = false;
    },
    //编辑 mouseEnter 事件
    editMouseEnter(tIndex) {
      this.operate_address_flag = parseInt(tIndex + 1);
      this.address_edit_flag = parseInt(tIndex + 1);
    },
    // 编辑 mouseOut 事件
    editMouseOut(tIndex, address_flag) {
      !address_flag
        ? (this.active_edit_flag = 0)
        : (this.address_edit_flag = 0);
    },
    //收货地址 mouseEnter 事件
    addressMouseEnter(tIndex) {
      this.operate_address_flag = parseInt(tIndex + 1);
    },
    //收货地址 mouseOut 事件
    addressMouseOut() {
      this.operate_address_flag = 0;
    },
    //选中当前收货地址
    getCheckedAddress(nInfo, nIndex) {
      this.name_checked_flag = parseInt(nIndex + 1);
      //更改运费
      this.getCalculateExpressFee();
    },
    //地址 name mouseEnter 事件
    nameItemEnter(tIndex) {
      this.operate_name_flag = parseInt(tIndex + 1);
    },
    //地址 name mouseOut 事件
    nameItemOut() {
      this.operate_name_flag = 0;
    },
    // 删除 mouseOver 事件
    delMouseEnter(tIndex) {
      this.operate_address_flag = parseInt(tIndex + 1);
      this.address_del_flag = parseInt(tIndex + 1);
    },
    // 删除 mouseLeaver 事件
    delMouseOut() {
      this.address_del_flag = 0;
    },
    // 更多地址 mouseOver 事件
    moreMouseEnter() {
      this.hover_click_flag = true;
    },
    // 更多地址 mouseLeaver 事件
    moreMouseOut() {
      this.hover_click_flag = false;
    },
    //删除收货地址
    delAddressInfo(dIndex) {
      this.$emit("delConfirm", {
        dIndex,
        select__flag: this.select_click_flag
      }); //调用主页面删除
    },
    //查看更多地址
    getLocationMore() {
      this.select_click_flag = !this.select_click_flag;
      this.getUserAddressAll("more"); //收货地址更多点击事件
    },
    //获取所有收货地址
    getUserAddressAll(m_flag, del_flag) {
      const loading = this.$loading({
        lock: true
      });
      // 获取商品数据
      const orderData = {
        // userId: this.userId
        //  userAddressId:null
      };
      this.apis.showOrder.getAddressAll(orderData).then(data => {
        if (!data.code) {
          // 赋值确认订单信息
          if (data.body.length < 1 || !data.body) {
            this.cardTableAddress = [];
          } else {
            //是否展示更多地址
            this.cardTableAddress_flag = data.body.length > 1 ? true : false;
            //判断是否存在新增、最后一次下单
            if (!!m_flag && !!this.lastAddressId) {
              let exchangArray = [...data.body];
              //不是新增情况下获取全部地址
              if (!this.address_newId) {
                this.address_newId = null;
                data.body.forEach((i, v) => {
                  if (i.id == this.lastAddressId) {
                    let lastAddress = i;
                    exchangArray.splice(v, 1);
                    exchangArray.unshift(lastAddress);
                  }
                });
              } else {
                data.body.forEach((i, v) => {
                  if (i.id == this.address_newId) {
                    let lastAddress = i;
                    exchangArray.splice(v, 1);
                    exchangArray.unshift(lastAddress);
                  }
                });
              }
              //判断是否是展示所有地址
              if (this.select_click_flag) {
                this.cardTableAddress = exchangArray;
              } else {
                this.name_checked_flag != 0 && !del_flag
                  ? (this.cardTableAddress = [
                      exchangArray[this.name_checked_flag - 1]
                    ])
                  : (this.cardTableAddress = [...exchangArray.slice(0, 1)]);
              }
            } else {
              //判断是否是展示所有地址
              this.select_click_flag
                ? (this.cardTableAddress = data.body)
                : (this.cardTableAddress = [...data.body.slice(0, 1)]);
            }
            m_flag != "more" ? (this.name_checked_flag = 0) : "";
            //关闭更多地址不调运费
            m_flag != "more" ? this.getCalculateExpressFee() : "";
          }
          loading.close();
        } else {
          loading.close();
          this.publicMethod.getThrowInfo(data.msg, "error");
        }
      });
    },
    //校验表单信息
    getCheckForm() {
      let check_flag = false;
      this.$refs["cardForm_kuaidi"].validate(valid => {
        if (valid) {
          check_flag = true;
        } else {
          check_flag = false;
        }
        this.$emit("formData", {
          check_flag: check_flag,
          card: this.cardForm_kuaidi.ownerIdCardNo.replace(/\s*/g, "")
        });
      });
    },
    //获取运费
    getCalculateExpressFee() {
      let userIndexData =
        this.name_checked_flag == 0 || this.cardTableAddress.length == 1
          ? this.cardTableAddress[0]
          : this.cardTableAddress[this.name_checked_flag - 1];

      let expressData = {
        goodsId: this.table_source.goodsId,
        city: userIndexData ? userIndexData.cityId : 145, //重置默认city
        cityName: userIndexData ? userIndexData.cityName : "上海",
        fetchticketId: this.table_source.fetchticketId,
        districtId: userIndexData ? userIndexData.regionId : '',
        districtName: userIndexData ? userIndexData.regionName : '',
        supplierId: this.table_source.supplierId,
      };
      this.apis.showOrder.getCalculateExpressFee(expressData).then(data => {
        if (!data.code) {
          // this.express_total_price = data.body;
          this.$emit("changeExpress", data.body);
        } else {
          //this.express_total_price = null;
          this.$emit("changeExpress", null);
          this.publicMethod.getThrowInfo(data.msg, "error");
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .user_ticket_info input::-webkit-input-placeholder {
  font-size: 14px;
  color: rgba(204, 204, 204, 1);
}
/deep/ .user_ticket_info input:-moz-placeholder {
  font-size: 14px;
  color: rgba(204, 204, 204, 1);
}
/deep/ .user_ticket_info input::-moz-placeholder {
  font-size: 14px;
  color: rgba(204, 204, 204, 1);
}
/deep/ .user_ticket_info input:-ms-input-placeholder {
  font-size: 14px;
  color: rgba(204, 204, 204, 1);
}
.ticket_info_location_more {
  width: 123px;
  cursor: pointer;
  span {
    display: inline-block;
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
  }
  img {
    width: 12px;
    height: 12px;
    margin-bottom: 2px;
    margin-left: 8px;
    display: inline-block;
    vertical-align: middle;
  }
}
.locaton_more_checked {
  span {
    color: rgba(61, 150, 226, 1);
  }
}
.active_background {
  background: #f4f9fe !important;
}
.ticket_info_user_item {
  background: #ffffff !important;
}
.ticket_info_address_add {
  color: rgba(51, 51, 51, 1) !important;
}
.address_move_flag_disabled {
  color: rgba(61, 150, 226, 1) !important;
}
.ticket_info_address_add img {
  width: 18px !important;
  height: 18px !important;
}
.ticket_info_address_add {
  font-size: 12px;
  height: 24px;
  color: rgba(61, 150, 226, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  &.ticket_info_user_add_disabled {
    background: #f7f7f7;
    color: #ccc;
  }
  img {
    width: 10px;
    height: 10px;
    margin-right: 4px;
  }
}
.ticket_info_address_add {
  font-size: 14px;
}
.info_left {
  span {
    color: rgba(102, 102, 102, 1) !important;
  }
  .user_item_card {
    margin-right: 0 !important;
  }
  .address_detail span,
  .address_detail a {
    line-height: 50px;
    display: block !important;
    max-width: 586px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.user_item_name {
  .drama_wrap_attr(140px, auto, 32px, 14px, rgba(51, 51, 51, 1), inherit);
  padding: 0 29px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block !important;
  text-align: center;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(229, 229, 229, 1);
}
.user_item_name_checked {
  border: 2px solid rgba(61, 150, 226, 1);
  background: url(../../assets/imgs/address_checked.png) right bottom no-repeat;
  background-size: 16px 16px;
}
.user_item_name_move {
  border: 2px solid rgba(61, 150, 226, 1);
}
.user_itm_name_address {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 84px !important;
  margin-left: 24px !important;
  margin-right: 16px !important;
}
.ticket_info_user_title {
  display: flex;
  justify-content: space-between;
  .way_title_left {
    display: flex;
    align-items: center;
  }
}
.ticket_icon {
  line-height: 21px;
}
.ticket_icon img {
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
}
.ticket_icon span {
  .drama_font_style(inherit, 500, 16px, 21px);
  display: inline-block;
  margin-left: 15px;
  color: rgba(17, 17, 17, 1);
  height: 21px;
}
.ticket_icon i {
  .drama_font_style(normal, 500, 12px, 16px);
  margin-left: 4px;
  color: rgba(102, 102, 102, 1);
}

.ticket_info_user_table {
  margin: 18px 0 8px 32px;
  /deep/ .user_ticket_info .el-form-item {
    margin: 24px 0 0 4px;
  }
  /deep/ .user_ticket_info .el-form-item__label {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
  }
  /deep/ .user_ticket_info .el-form-item__content {
    width: 320px;
  }
  /deep/ .user_ticket_info .el-input__inner {
    width: 320px;
    height: 32px;
    border-radius: 0;
    color: #000000;
  }
  .user_ticket_info {
    .code_verification {
      color: rgba(17, 17, 17, 1);
    }
  }
  .ticket_info_empty {
    font-size: 12px;
    color: rgba(204, 204, 204, 1);
    line-height: 16px;
    margin: 1px 0 24px;
  }

  .ticket_info_user_item {
    .drama_wrap_attr(100%, 50px, 50px, 14px, rgba(17, 17, 17, 1), inherit);
    background: rgba(250, 250, 250, 1);
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .info_left {
      align-items: center;
      display: flex;
    }
    .operate_right {
      margin-right: 20px;
      display: flex;
      align-items: center;
      a {
        font-size: 14px;
        display: inline-block;
        span {
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
        }
      }
      .active_edit {
        span {
          color: rgba(61, 150, 226, 1);
        }
      }
      .edit_left {
        margin-right: 30px;
      }
      img {
        width: 16px;
        height: 16px;
        margin: 2px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 2px;
        margin-top: 0px;
      }
    }
    span {
      display: inline-block;
    }

    .user_itm_name {
      width: 68px;
      margin-left: 28px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .user_item_line {
      width: 1px;
      height: 20px;
      background: rgba(237, 237, 237, 1);
      margin: 0 32px;
    }
    .user_item_line_id {
      width: 1px;
      height: 20px;
      background: rgba(237, 237, 237, 1);
      margin: 0 28px;
    }
    .user_item_card {
      margin-right: 24px;
    }
  }
}
</style>
<style lang="less">
.ticket-mobile-dialog {
  /deep/ .el-dialog {
    .el-dialog__header {
      padding: 16px 60px;
      line-height: 24px;
    }
    .el-dialog__title {
      font-size: 18px;
      color: #111;
      font-weight: 700;
    }
    .el-dialog__body {
      padding: 24px 60px 32px;
    }
    .el-form-item {
      margin: 0;
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .el-form-item__label {
      font-size: 14px;
      line-height: 40px;
      &::before {
        content: none !important;
      }
    }
    .el-input {
      height: 40px;
      .el-input__inner {
        border-color: #e5e5e5;
        font-size: 14px;
      }
    }
    .get-code {
      position: relative;
    }
    .el-button {
      width: 120px;
      height: 40px;
      font-size: 14px;
      margin-left: 20px;
      border-radius: 4px;
      &.submit-btn {
        background: linear-gradient(
          315deg,
          rgba(92, 180, 236, 1) 0%,
          rgba(61, 150, 226, 1) 100%
        );
      }
      &.cancel-btn {
        border: 1px solid #e5e5e5;
        color: #666;
        background: #fff;
        &:hover {
          border: 1px solid #e5e5e5;
          color: #666;
          background: #fff;
        }
      }
    }
  }
}
.ticket-mobile-address {
  .address_title {
    font-size: 12px;
    color: rgba(153, 153, 153, 1);
    line-height: 16px;
    display: flex;
    margin-bottom: 24px;

    .title_left {
      position: relative;
      color: rgba(17, 17, 17, 1);
      width: 69px;
      display: flex;
    }
    .title_left:before {
      display: block;
      color: #f56c6c !important;
      content: "*";
      margin-right: 0 !important;
    }
    .title_right {
      display: flex;
      flex: 1;
    }
  }
  .el-dialog {
    .el-dialog__header::after {
      width: 100% !important;
    }
    .el-dialog__body {
      padding: 16px 64px 32px !important;
    }
    .el-input,
    .el-select {
      width: calc(100% - 13px);
      .el-input {
        width: 100%;
      }
    }
    .el-form-item__error {
      left: 13px;
    }
    .el-form-item__label {
      font-size: 14px;
      line-height: 32px;
    }
    .el-input {
      font-size: 14px;
      height: 32px !important;
    }
    .location_area_wrap {
      .el-input {
        width: 100% !important;
      }
      .location_arrow {
        position: absolute;
        top: 10px;
        right: 13px;
        width: 12px;
        height: 12px;
        display: inline-block;
        vertical-align: middle;
      }
      .location_area {
        position: absolute;
        top: 32px;
        left: 0;
        z-index: 9;
        width: 540px;
        min-height: 194px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.05);
        border: 1px solid rgba(229, 229, 229, 1);
      }
    }

    .el-form-item__label {
      margin-right: 13px;
      &::before {
        content: "*" !important;
        margin-right: 0px !important;
        color: #f56c6c !important;
      }
    }
    .check_none {
      .el-form-item__label {
        &::before {
          color: #ffffff !important;
        }
      }
    }
    .el-dialog__footer {
      text-align: left;
      margin-left: 103px;
    }
    .submit-btn {
      width: 112px;
      height: 40px;
      background: linear-gradient(
        315deg,
        rgba(92, 180, 236, 1) 0%,
        rgba(61, 150, 226, 1) 100%
      );
      border-radius: 4px;
      span {
        font-weight: bold !important;
      }
    }
    .cancel-btn {
      margin-left: 24px;
    }
  }
}
.qr_code_add {
  height: 32px;
  font-size: 12px;
  padding: 8px 12px;
  padding-top: 7px;
  background: rgba(254, 243, 243, 1);
  box-shadow: 0px 1px 2px 0px rgba(212, 98, 98, 0.2);
  span {
    display: inline-block;
    color: rgba(244, 69, 69, 1) !important;
    line-height: 16px;
  }
  img {
    margin-top: 2px;
    width: 13px;
    height: 13px;
  }
}
/deep/ .qr_code_add .popper__arrow {
  background: rgba(254, 243, 243, 1);
  box-shadow: 0px 1px 2px 0px rgba(212, 98, 98, 0.2);
}
.qr_code_add .popper__arrow::after {
  border-left-color: rgba(254, 243, 243, 1) !important;
}
.more_rotate {
  transform: rotateX(180deg);
}
.label-one label{
  //  width: auto!important;
  //  margin-right: 7px!important;;
}
.label-one-Tab label{
     width: 155px!important;
}
.label-one-Tab .el-input{
    //  margin-left: 90px!important;
     width: 450px!important;
}
.label-one-Tab .el-form-item__error{
    padding-left: 105px;
    &::before {
          margin-left: 90px!important;
      }
}
.label-one-Wat .el-input__inner{
   margin-left: 90px!important;
   width: 450px!important;
}
.label-one-Wat .el-form-item__error{
    padding-left: 105px;
    &::before {
          margin-left: 90px!important;
      }
}
</style>
